export const serviceType = {
  hotel: "ホテル",
  flight: "フライト",
  optionalTour: "現地ツアー",
  railway: "鉄道",
  additionalBaggage: "預け入れ手荷物",
};
